export default __webpack_public_path__ + "static/media/store.f037d740.svg";